
<div class="finance-payroll-timesheet" cdkDropListGroup>

  <!--Filter and Bulk Update-->

  <div class="page-container">
    <div class="page-container box-dash">
      <div class="row">
        <div *ngIf="operationTalentDept"
             class="tpm-box-timesheetPg-hdr-bar">
          <h2 class="tpm-box-dash-hdr" *ngIf="timesheetDetail" [innerHtml]="timesheetDetail.name + ' ' + timesheetDetail.businessUnit.name">
         
          </h2>
        </div>


        <div *ngIf="financePayrollDept"
             class="tpm-box-timesheetPg-hdr-bar">
          <h2 class="tpm-box-dash-hdr">Timecards {{departments[0].businessUnit.displayName}}</h2>
        </div>


        <div class="col-lg-12 timecard-filter">
          <div class="col-lg-11">
            <div class="timecard-filter" *ngIf="buAccess && departments?.length>0 && employeeTypes?.length>0">
              <grid-filters [workFlowId]="WorkFlowId"
                            [buAccess]="buAccess"
                            [departments]="departments"
                            [employeeTypes]="employeeTypes"
                            [workStates]="workStates"></grid-filters>
            </div>
          </div>

          <div class="col-lg-1 float-end ps-3 pe-3">
            <div class="float-end">
              <a class="btn btn-icon btn-contact-search" (click)="showContactSearchFlyout()">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-male fa-stack-2x"></i>
                  <i class="fa fa-search fa-flip-horizontal fa-stack-2x fa-search-bg"></i>
                  <i class="fa fa-search fa-flip-horizontal fa-stack-2x"></i>
                </span>
              </a>
            </div>
            <div>
              <contact-flyover></contact-flyover>
            </div>
          </div>
        </div>



      </div>

      <div class="row static-area1">
        <div class="static-area p-0">
          <div class="row">
            <div class="col-sm-12">
              <nbc-alert></nbc-alert>
            </div>
          </div>
          <div class="content-filters" style="margin-bottom:0 !important">
            <div class="row view-options" *ngIf="queryContainer.query.totalRecords > 0">
              <div class="col-md-7 d-flex">
                <div class="col-md-4">
                  <div class="form-inline form-sort-options">
                    <div class="form-group" style="margin-bottom:0 !important">
                      <div class="form-group">
                        <nbc-page-size [source]='pageSize'
                            [model]="queryContainer.query.pageSize"
                            (nbcValueChange)="searchPage($event)">
                        </nbc-page-size>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div *ngFor="let dept of departments"
                       class="timesheetPg-operationtalentstatus">
                    <div class="timesheet-legend-status timesheet-status-{{dept.department.externalKey}}"></div>
                    <div class="timesheet-legend-text">{{dept.department.name}}</div>
                  </div>
                  <div class="timesheetPg-operationtalentstatus">
                    <div class="timesheetPg-legend-status timesheetPg-status-approved"></div>
                    <div class="timesheetPg-legend-text">
                      Approved
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group pagination-container d-flex" style="margin-bottom:0">
                  <label class="pagination-results ms-auto">
                      <pagination-label pageSize="{{queryContainer.query.pageSize}}"
                                        currentPage="{{queryContainer.query.currentPage}}"
                                        totalRecords="{{queryContainer.query.totalRecords}}"></pagination-label>
                  </label>
                  <nbc-pagination totalItems="{{queryContainer.query.totalRecords}}"
                                  itemsPerPage="{{queryContainer.query.pageSize}}"
                                  [currentPage]="queryContainer.query.currentPage"
                                  (pageChanged)="onPageNumberClicked($event)"></nbc-pagination>
                </div>
              </div>
            </div>

            <div class="row row-bulk-update group-update">
              <div *ngIf="showBulkUpdateMenu" class="col-md-7">
                <div class="form-inline group-update-form payroll-timesheet-group-action d-flex">
                  <div class="form-group">
                    <label class="group-update-label">GROUP ACTION:</label>
                  </div>
                  <div class="form-group" *ngIf="groupUpdateOptions?.length>0">
                    <nbc-select [source]="groupUpdateOptions"
                                [(model)]="bulkSelectedOption"
                                display="description"
                                value="id"
                                name="bulkoption"
                                placeHolderValue="-1"
                                placeHolderDisplay="Select Field"
                                (modelChange)="bulkEntry=''"></nbc-select>
                  </div>
                  <div *ngIf="bulkSelectedOption?.id==6"
                       class="form-group d-flex">
                    <div class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="groupUpdateTimecardOptions"
                                  [(model)]="bulkFieldSelectedOption"
                                  display="description"
                                  value="id"
                                  name="bulkoption"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Field"
                                  (modelChange)="bulkEntryField = {}"></nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==21"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="employeeTypes"
                                  [(model)]="bulkEntryField.employeeType"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_employee"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Field"></nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==22"
                         class="form-group" style="margin-bottom:0 !important">
                      <div class="input-group date col-md-12 dateselecter d-flex">
                        <input type="text"
                               name="filter_startDate"
                               class="form-control activity-date-focus filter-activityDate"
                               ngModel
                               bsDatepicker
                               #drp="bsDatepicker"
                               [(ngModel)]="bulkEntryField.activityDate"
                               [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}" />
                        <span class="input-group-text">
                          <button style="border: none;background: white;"
                                  (click)="drp.toggle()"
                                  [attr.aria-expanded]="drp.isOpen"
                                  type="button">
                                      <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==23"
                         class="form-group hours-worked" style="margin-bottom:0 !important">
                      <input type="text"
                             appInputRestriction="numberOnly"
                             [(ngModel)]="bulkEntryField.hoursWorked"
                             maxlength="2">
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==24"
                         class="form-group text-update" style="margin-bottom:0 !important">
                      <input type="text"
                             placeholder="Event/Show Name"
                             [(ngModel)]="bulkEntryField.eventShowName"
                             maxlength="255">
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==41"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="daytypes"
                                  [(model)]="bulkEntryField.dayType"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_dayType"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Field"></nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==25"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="networks"
                                  [(model)]="bulkEntryField.network"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_network"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Field"></nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==26"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="workStates"
                                  [(model)]="bulkEntryField.workstate"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_workstate"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Field"></nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==27"
                         class="form-group" style="margin-bottom:0 !important">
                      <input type="text"
                             required
                             name="customRateEntry"
                             nbc-decimal
                             decimals="255"
                             autocomplete="off"
                             [(ngModel)]="bulkEntryField.customRate"
                             placeholder="Enter Rate"
                             class="form-control form-control-sm" />
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==28"
                         class="form-group" style="margin-bottom:0 !important">
                      <div class="grid-itm wbse-costcenter">
                        <div class="cost-options p-0">
                          <input type="radio"
                                 [(ngModel)]="bulkEntryField.wbseOption"
                                 value="wbseOption"
                                 name="costCenter"
                                 id="wbseOption"
                                 (click)="bulkEntryField.wbseCode={}" />
                          <label style="font-weight:bold" for="wbseOption">WBSE</label>
                          <input type="radio"
                                 [(ngModel)]="bulkEntryField.wbseOption"
                                 value="ccOption"
                                 name="costCenter"
                                 (click)="bulkEntryField.wbseCode={}" />
                            <label for="wbseOption">CC</label>
                        </div>

                        <div *ngIf="bulkEntryField.wbseOption=='wbseOption'" class="wbse-input">
                          <input type="text"
                                 style="float:left"
                                 [(ngModel)]="bulkEntryField.wbseCode.code" />
                          <button class="btn btn-primary btncls wbse-el" style="margin-bottom: 0px !important; margin-top: -1px !important; margin-left: -1px !important; "
                                  (click)="openWBSEModal()">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                        <div *ngIf="bulkEntryField.wbseOption=='ccOption'"
                             class="cost-center-input">
                          <input type="text"
                                 class="required-outline"
                                 [(ngModel)]="bulkEntryField.wbseCode.code" />
                        </div>
                      </div>
                    </div>

                    <div *ngIf="bulkFieldSelectedOption?.id==29"
                         class="form-group" style="margin-bottom:0 !important">
                      <div class="group-gla payroll-glaccount">
                        <glaccount name="bulkUpdate_glAccount"
                                   placeHolder="Enter GL Account"
                                   [(model)]="bulkEntryField.glAccount"
                                   typeaheadOptionLimit="10">
                        </glaccount>
                      </div>
                    </div>

                    <div *ngIf="bulkFieldSelectedOption?.id==30"
                         class="form-group d-flex">

                      <nbc-select [source]="contractCodes"
                                  [model]="bulkEntryField.contractCode"
                                  [nbcClass]="bulk-contract-code"
                                  display="name"
                                  value="name"
                                  name="bulkUpdate_contractCode"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Contract Code"
                                  (modelChange)="onContractCodeSelected($event)"></nbc-select>
                      <button *ngIf="(bulkEntryField.contractCode && !bulkEntryField.payTransactions) || (bulkEntryField.contractCode && bulkEntryField.payTransactions.length === 0)"
                              class="btn btn-primary bulk-transactions"
                              [attr.disabled]="!bulkEntryField.contractCode||null"
                              (click)="onOpenPayTransaction(bulkEntryField, true)"
                              style="max-width:105px;overflow-wrap:break-word;font-size:11px;margin:3px;">
                        Pay Transaction
                      </button>
                      <button *ngIf="bulkEntryField.contractCode && bulkEntryField.payTransactions && bulkEntryField.payTransactions.length > 0"
                              class="btn btn-link bulk-transactions"
                              [attr.disabled]="!bulkEntryField.contractCode || null"
                              (click)="onOpenPayTransaction(bulkEntryField, true)">
                        {{bulkEntryField.payTransactions.length}} transaction(s)
                      </button>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==31"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="payrollProviders"
                                  [(model)]="bulkEntryField.payrollProvider"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_payrollProvider"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select"></nbc-select>
                    </div>

                    <div *ngIf="bulkFieldSelectedOption?.id == 32"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="jobcodeForBulkUpdate"
                                  [(model)]="bulkEntryField.jobCode"
                                  [nbcClass]="bulk-contract-code"
                                  [nbcRequired]="true"
                                  display="code"
                                  value="code"
                                  name="bulkUpdate_jobCode"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Job Code"
                                  (modelChange)="filterRateCodes()"></nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id == 32"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="rateCodes"
                                  [(model)]="bulkEntryField.rateCode"
                                  [nbcClass]="bulk-contract-code"
                                  display="rateCode"
                                  value="rateCode"
                                  name="bulkUpdate_rateCodeSelect"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Rate Code">
                      </nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id == 33"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="sports"
                                  [(model)]="bulkEntryField.sport"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_sport"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Sport">
                      </nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id == 34"
                         class="form-group" style="margin-bottom:0 !important">
                      <nbc-select [source]="unionCodes"
                                  [(model)]="bulkEntryField.unionCode"
                                  display="description"
                                  value="id"
                                  name="bulkUpdate_unionCode"
                                  placeHolderValue="-1"
                                  placeHolderDisplay="Select Union Code">
                      </nbc-select>
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==35"
                         class="form-group text-update" style="margin-bottom:0 !important">
                      <input type="text"
                             placeholder="Wage Type"
                             [(ngModel)]="bulkEntryField.wageType"
                             maxlength="4">
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==36"
                         class="form-group text-update" style="margin-bottom:0 !important">
                      <input type="text" appInputRestriction="numberOnly"
                             placeholder="Wage Schedule"
                             [(ngModel)]="bulkEntryField.wageschedule"
                             maxlength="2">
                    </div>
                    <div *ngIf="bulkFieldSelectedOption?.id==40"
                         class="form-group text-update" style="margin-bottom:0 !important">
                      <input type="text"
                             placeholder="Cost Center"
                             [(ngModel)]="bulkEntryField.payrollCostCenter"
                             maxlength="30">
                    </div>
                  </div>

                  <div *ngIf="bulkSelectedOption?.id"
                       class="form-group">
                    <button class="btn btn-secondary"
                            (click)="bulkUpdate()">
                      Update
                    </button>
                  </div>
                  <div class="form-group">
                    <button class="btn btn-default"
                            (click)="closeBulkUpdateMenu()">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="showsortAlert"
                   class="col-md-2">
                <span class="timecardsorttext">Timecard(s) saved and auto sorted</span>
              </div>
              <div *ngIf="queryContainer.query.totalRecords>0"
                   class="col-md-5 ms-auto">
                <div class="form-inline float-end">
                  <!--@**ngIf="buAccess.department=='PAYROLL'"*@-->
                  <div class="form-group">
                    <button class="btn btn-secondary timesheet-exportbtn"
                            (click)="exportReportTimecards()">
                      Export Timecards
                    </button>
                  </div>
                  <div *ngIf="buAccess.department=='PAYROLL'" class="form-group">
                    <button
                            class="btn btn-secondary timesheet-exportbtn"
                            (click)="exportTimecards()"
                            authenticate-user="Timecard.SPB.Report.Export"
                            authenticate-command="disabled">
                      SP Export
                    </button>
                  </div>
                  <div *ngIf="buAccess.department=='PAYROLL'" class="form-group">
                    <button
                            class="btn btn-secondary"
                            (click)="previewSPBTimecards()">
                      SP Preview
                    </button>
                  </div>
                  <div *ngIf="selectedTimesheetListItems.length>0"
                       class="form-group">
                    <button class="btn btn-success"
                            (click)="onGlobalSubmitSelected()"
                            authenticate-user="Timecard.Submitter.Submit.Retrieve,Timecard.Approver.Submit.Retrieve
                                                        ,Timecard.Finance.Submit.Retrieve
                                                        ,Timecard.Payroll.Submit.Retrieve"
                            authenticate-command="disabled">
                      Submit
                    </button>
                  </div>
                  <div *ngIf="selectedTimesheetListItems.length>0"
                       class="form-group">
                    <button class="btn btn-success"
                            (click)="draftSaveAllTimecards()"
                            authenticate-user="Timecard.Submitter.Save.Retrieve,Timecard.Approver.Save.Retrieve
                                                        ,Timecard.Finance.Save.Retrieve
                                                        ,Timecard.Payroll.Save.Retrieve"
                            authenticate-command="disabled">
                      Save
                    </button>
                  </div>
                  <div class="form-group">
                    <button class="btn btn-secondary"
                            (click)="cancelEdits()">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="queryContainer.query.totalRecords == 0"
             style="text-align:center;padding:15px;">
          No Record Found
        </div>
      </div>
    </div>
  </div>



  <!--Grid Section Starts-->
  <timesheet-grid></timesheet-grid>
</div>
<app-nbc-file-download></app-nbc-file-download>
